import { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';

const gib = (bytes) => `${(bytes / 1024 ** 3).toFixed(1)} GiB`;

export default function StorageCapacityBanner({ client, enabled = false }) {
  const [health, setHealth] = useState(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    setHealth(null);
    if (!enabled) return undefined;
    let active = true;
    let timer;
    const check = async () => {
      try {
        const response = await client.get('/api/admin/storage/upload-storage');
        if (active) setHealth(response.data.data);
      } catch {
        if (active) setHealth({ severity: 'unavailable', message: 'Upload storage monitoring is unavailable. Retry the check or contact your hosting administrator.' });
      } finally {
        if (active) timer = setTimeout(check, 60000);
      }
    };
    check();
    return () => { active = false; clearTimeout(timer); };
  }, [client, enabled, retry]);

  if (!enabled || !health || health.severity === 'healthy') return null;
  const critical = ['critical', 'full'].includes(health.severity);
  return (
    <Alert variant={critical ? 'danger' : 'warning'} role="alert" className="mt-3">
      <strong>{critical ? 'High risk: upload storage capacity' : 'Upload storage needs attention'}</strong>
      <div>{health.message}</div>
      {Number.isFinite(health.usedPercent) && (
        <div className="small mt-1">
          {health.backend === 'gcs' ? 'Cloud storage budget' : 'Upload disk'}: {health.usedPercent.toFixed(1)}% used
          {' · '}{gib(health.availableBytes)} remaining of {gib(health.capacityBytes)}.
        </div>
      )}
      {health.measurementScope && <div className="small">{health.measurementScope}</div>}
      <Button variant="outline-dark" size="sm" className="mt-2" onClick={() => setRetry((value) => value + 1)}>Check again</Button>
    </Alert>
  );
}
